<template>
    <article class="article --sport-apps">
        <section class="article__intro">
            <div class="container">
                <h1 v-html="$t('articles.sportApps.title')"></h1>
            </div>
            <div class="article__intro__scrolldown" v-scroll-to="'.article__body'"></div>
        </section>   

        <section class="article__body pt-xs-40 pb-xs-100">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <p class="article__intro__txt t-center t-color-third mb-xs-60" v-html="$t('articles.sportApps.intro')"></p>

                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-xs-20">1. {{ $t('articles.sportApps.app1.title') }}</h3>
                            </div>
                            <div class="col-sm-3">
                                <img class="mb-xs-20 mb-sm-0" src="../../assets/img/runtastic.png">
                            </div>
                            <div class="col-sm-9">
                                <p>{{ $t('articles.sportApps.app1.description') }}</p>
                                <a href="https://play.google.com/store/apps/details?id=com.runtastic.android" target="_blank" class="store --play-store mr-xs-20"><img src="../../assets/img/play-store.png" alt="Google Play"></a>
                                <a href="https://apps.apple.com/be/app/id1035263816" target="_blank" class="store --app-store mr-xs-20"><img src="../../assets/img/app-store.png" alt="App Store"></a>
                            </div>
                        </div>

                        <div class="separator"></div>

                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-xs-20">2. {{ $t('articles.sportApps.app2.title') }}</h3>
                            </div>
                            <div class="col-sm-3">
                                <img class="mb-xs-20 mb-sm-0" src="../../assets/img/fitify.png">
                            </div>
                            <div class="col-sm-9">
                                <p>{{ $t('articles.sportApps.app2.description') }}</p>
                                <a href="https://play.google.com/store/apps/details?id=com.fitifyworkouts.bodyweight.workoutapp" target="_blank" class="store --play-store mr-xs-20"><img src="../../assets/img/play-store.png" alt="Google Play"></a>
                                <a href="https://apps.apple.com/us/app/fitify-fitness-home-workout/id1463386686" target="_blank" class="store --app-store mr-xs-20"><img src="../../assets/img/app-store.png" alt="App Store"></a>
                            </div>
                        </div>

                        <div class="separator"></div>

                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-xs-20">3. {{ $t('articles.sportApps.app3.title') }}</h3>
                            </div>
                            <div class="col-sm-3">
                                <img class="mb-xs-20 mb-sm-0" src="../../assets/img/7-min.png">
                            </div>
                            <div class="col-sm-9">
                                <p>{{ $t('articles.sportApps.app3.description') }}</p>
                                <a href="https://play.google.com/store/apps/details?id=com.popularapp.sevenmins" target="_blank" class="store --play-store mr-xs-20"><img src="../../assets/img/play-store.png" alt="Google Play"></a>
                                <a href="https://apps.apple.com/be/app/7-minute-workout-fitness-app/id806995720?l=nl" target="_blank" class="store --app-store mr-xs-20"><img src="../../assets/img/app-store.png" alt="App Store"></a>
                            </div>
                        </div>

                        <div class="separator"></div>

                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-xs-20">4. {{ $t('articles.sportApps.app4.title') }}</h3>
                            </div>
                            <div class="col-sm-3">
                                <img class="mb-xs-20 mb-sm-0" src="../../assets/img/yoga.png">
                            </div>
                            <div class="col-sm-9">
                                <p>{{ $t('articles.sportApps.app4.description') }}</p>
                                <a href="https://play.google.com/store/apps/details?id=net.workoutinc.yoga.beginners.free.workouts.studio" target="_blank" class="store --play-store mr-xs-20"><img src="../../assets/img/play-store.png" alt="Google Play"></a>
                                <a href="https://apps.apple.com/us/app/yoga-for-beginners-mind-body/id1382141225" target="_blank" class="store --app-store mr-xs-20"><img src="../../assets/img/app-store.png" alt="App Store"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> 

        <section class="article__tip">
            <div class="container">
                <h2 class="t-color-sport dots mb-xs-15">{{ $t('common.tip') }}</h2>
                <p class="article__tip__txt">{{ $t('articles.sportApps.tip') }}</p>
            </div>
        </section>

        <section class="pt-xs-100 pb-xs-100">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-xs-20">5. {{ $t('articles.sportApps.app5.title') }}</h3>
                            </div>
                            <div class="col-sm-3">
                                <img class="mb-xs-20 mb-sm-0" src="../../assets/img/30-day.png">
                            </div>
                            <div class="col-sm-9">
                                <p>{{ $t('articles.sportApps.app5.description') }}</p>
                                <a href="https://play.google.com/store/apps/details?id=com.bendingspoons.thirtydayfitness" target="_blank" class="store --play-store mr-xs-20"><img src="../../assets/img/play-store.png" alt="Google Play"></a>
                                <a href="https://apps.apple.com/app/id1099771240" target="_blank" class="store --app-store mr-xs-20"><img src="../../assets/img/app-store.png" alt="App Store"></a>
                            </div>
                        </div>

                        <div class="separator"></div>

                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-xs-20">6. {{ $t('articles.sportApps.app6.title') }}</h3>
                            </div>
                            <div class="col-sm-3">
                                <img class="mb-xs-20 mb-sm-0" src="../../assets/img/sixpack.png">
                            </div>
                            <div class="col-sm-9">
                                <p>{{ $t('articles.sportApps.app6.description') }}</p>
                                <a href="https://play.google.com/store/apps/details?id=sixpack.sixpackabs.absworkout" target="_blank" class="store --play-store mr-xs-20"><img src="../../assets/img/play-store.png" alt="Google Play"></a>
                                <a href="https://apps.apple.com/nl/app/sixpack-buikspieroefeningen/id1338655056" target="_blank" class="store --app-store mr-xs-20"><img src="../../assets/img/app-store.png" alt="App Store"></a>
                            </div>
                        </div>

                        <div class="separator"></div>

                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-xs-20">7. {{ $t('articles.sportApps.app7.title') }}</h3>
                            </div>
                            <div class="col-sm-3">
                                <img class="mb-xs-20 mb-sm-0" src="../../assets/img/pilates.png">
                            </div>
                            <div class="col-sm-9">
                                <p>{{ $t('articles.sportApps.app7.description') }}</p>
                                <a href="https://play.google.com/store/apps/details?id=com.blogilates.body" target="_blank" class="store --play-store mr-xs-20"><img src="../../assets/img/play-store.png" alt="Google Play"></a>
                                <a href="https://apps.apple.com/us/app/body-by-blogilates/id1520242025" target="_blank" class="store --app-store mr-xs-20"><img src="../../assets/img/app-store.png" alt="App Store"></a>
                            </div>
                        </div>

                        <div class="separator"></div>

                        <div class="row">
                            <div class="col-12">
                                <h3 class="mb-xs-20">8. {{ $t('articles.sportApps.app8.title') }}</h3>
                            </div>
                            <div class="col-sm-3">
                                <img class="mb-xs-20 mb-sm-0" src="../../assets/img/strava.png">
                            </div>
                            <div class="col-sm-9">
                                <p>{{ $t('articles.sportApps.app8.description') }}</p>
                                <a href="https://play.google.com/store/apps/details?id=com.strava" target="_blank" class="store --play-store mr-xs-20"><img src="../../assets/img/play-store.png" alt="Google Play"></a>
                                <a href="https://apps.apple.com/nl/app/strava-gps-running-and-cycling/id426826309" target="_blank" class="store --app-store mr-xs-20"><img src="../../assets/img/app-store.png" alt="App Store"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="article__related pt-xs-60 pb-xs-120">
            <div class="container">
                <h3 class="text-center mb-xs-40">{{ $t('articles.common.related') }}</h3>
            </div>
            <div v-swiper:relatedSwiper="relatedSwiperOptions">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.sport.kiwi')}">
                                <img src="../../assets/img/articles/thumb-1.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.sportKiwi.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.mind.humeur')}">
                                <img src="../../assets/img/articles/thumb-3.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.mindHumeur.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.mind.lachen')}">
                                <img src="../../assets/img/articles/thumb-4.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.mindLachen.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.food.ontbijt')}">
                                <img src="../../assets/img/articles/thumb-5.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.foodOntbijt.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.food.fruit')}">
                                <img src="../../assets/img/articles/thumb-6.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.foodFruit.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-navigation">
                <div class="swiper-navigation-button swiper-navigation-button--prev" v-on:click="relatedSwiper.slidePrev()"></div>
                <div class="swiper-navigation-button swiper-navigation-button--next" v-on:click="relatedSwiper.slideNext()"></div>
            </div>
        </section>

        <section class="article__blog pt-xs-40 pt-md-100 pb-xs-20 pb-md-100">
            <div class="container">
                <h3 class="text-center mb-xs-40">{{ $t('articles.common.moreBlog') }}</h3>
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="article-link mb-xs-20 mb-sm-0">
                                    <a :href="$t('blog.article1.url')" target="_blank">
                                        <img src="../../assets/img/articles/thumb-blog-1.jpg">
                                        <div class="p-xs-5 p-md-15">
                                            <div class="article-link__title --blog">{{ $t('blog.article1.title') }}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="article-link">
                                    <a :href="$t('blog.article2.url')" target="_blank">
                                        <img src="../../assets/img/articles/thumb-blog-2.jpg">
                                        <div class="p-xs-5 p-md-15">
                                            <div class="article-link__title --blog">{{ $t('blog.article2.title') }}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </article>
</template>

<script>

export default {
  name: "SportApps",
  data() {
    return {
        relatedSwiperOptions: {
            loop: false,
            direction: 'horizontal',
            spaceBetween: 30,
            breakpoints: {
                320: {
                slidesPerView: 1.2
                },
                640: {
                slidesPerView: 2.4
                },
                992: {
                slidesPerView: 4.6
                }
            }
        }
    }
  },
  mounted() {
  },
};
</script>